import Api, { apiAction } from '../api'
import { ActionTypes } from '../constants'
import { User } from '@app/models/users'

function participationRequest() {
  return {
    type: ActionTypes.PARTICIPATE_REQUEST
  }
}

function participationSuccess(response) {
  return {
    type: ActionTypes.PARTICIPATE_SUCCESS,
    user: new User(response.data)
  }
}

function participationFailure(error) {
  return {
    type: ActionTypes.PARTICIPATE_FAILURE,
    error: error
  }
}

export const participate = ({ tour }) => {
  return apiAction({
    requestor: () => Api.students.participations({ tour }).create(),
    onBeforeSend: participationRequest,
    onSuccess: (response) => participationSuccess(response),
    onFailure: (error) => participationFailure(error)
  })
}

function tasksRequest(tour) {
  return {
    type: ActionTypes.TASKS_REQUEST,
    tour: tour
  }
}

function tasksReceived(tour, response) {
  return {
    type: ActionTypes.TASKS_RECEIVING_SUCCESS,
    tour: tour,
    tasks: response.data,
    updatedOn: Date.now()
  }
}

function tasksReceivingFailure(tour, error) {
  return {
    type: ActionTypes.TASKS_RECEIVING_FAILURE,
    tour: tour,
    error: error
  }
}

function fetchTasks(tour) {
  return apiAction({
    requestor: () => Api.students.tasks({ tour }).index(),
    onBeforeSend: () => tasksRequest(tour),
    onSuccess: (response) => tasksReceived(tour, response),
    onFailure: (error) => tasksReceivingFailure(tour, error)
  })
}

function shouldFetchTasks(state, tour) {
  let { students: { tasks } } = state
  let statistics = tasks[tour]

  if (!statistics) { return true }

  let { updatedOn, fetching, didInvalidate } = statistics

  if (fetching) {
    return false
  } else if (didInvalidate) {
    return true
  } else {
    return !updatedOn || (new Date() - updatedOn) > 60000
  }
}

function tourInvalidation(tour) {
  return {
    type: ActionTypes.TASKS_INVALIDATION,
    tour: tour
  }
}

export function invalidateTasks(tour) {
  return (dispatch) => {
    return dispatch(tourInvalidation(tour))
  }
}

export function fetchTasksIfNeeded(tour) {
  return (dispatch, getState) => {
    if (shouldFetchTasks(getState(), tour)) {
      return dispatch(fetchTasks(tour))
    }
  }
}

function taskRateRequest(task) {
  return {
    type: ActionTypes.TASK_RATE_REQUEST,
    task: task
  }
}

function tasksRated(task, response) {
  return {
    type: ActionTypes.TASK_RATE_SUCCESS,
    task: task,
    rating: response.data
  }
}

function taskRateFailure(task, error) {
  return {
    type: ActionTypes.TASK_RATE_FAILURE,
    task: task,
    error: error
  }
}

export const rateTask = (task, { rating }) => {
  return apiAction({
    requestor: () => Api.students.ratings({ id: task.id }).create({ rating }),
    onBeforeSend: () => taskRateRequest(task),
    onSuccess: (response) => tasksRated(task, response),
    onFailure: (error) => taskRateFailure(task, error)
  })
}

function finishOlympiadRequest() {
  return {
    type: ActionTypes.FINISH_OLYMPIAD_REQUEST
  }
}

function finishOlympiadSuccess(response) {
  return {
    type: ActionTypes.FINISH_OLYMPIAD_SUCCESS,
    user: new User(response.data)
  }
}

function finishOlympiadFailure(error) {
  return {
    type: ActionTypes.FINISH_OLYMPIAD_FAILURE,
    error: error
  }
}

export const finishOlypiad = ({ tour }) => {
  return apiAction({
    requestor: () => Api.students.participations({ tour }).delete({ id: 'me' }),
    onBeforeSend: finishOlympiadRequest,
    onSuccess: (response) => finishOlympiadSuccess(response),
    onFailure: (error) => finishOlympiadFailure(error)
  })
}

function restartOlympiadRequest() {
  return {
    type: ActionTypes.RESTART_OLYMPIAD_REQUEST
  }
}

function restartOlympiadSuccess(response) {
  return {
    type: ActionTypes.RESTART_OLYMPIAD_SUCCESS,
    user: new User(response.data)
  }
}

function restartOlympiadFailure(error) {
  return {
    type: ActionTypes.RESTART_OLYMPIAD_FAILURE,
    error: error
  }
}

export const restartOlypiad = ({ tour }) => {
  return apiAction({
    requestor: () => Api.students.restarts({ tour }).create(),
    onBeforeSend: restartOlympiadRequest,
    onSuccess: (response) => restartOlympiadSuccess(response),
    onFailure: (error) => restartOlympiadFailure(error)
  })
}
